import * as React from 'react';
import { NotificationType } from '../Utils';

import {
  Stack,
  Snackbar,
  Alert,
  styled
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { FEATURE_CUSTOM_PAYMENT } from '../../../../constant';
import { setNotificationMessage } from '../payment-reducer/actions';


const StyledAlert = styled(Alert)({
  '&.MuiAlert-root': {
    fontSize: "14px",
    width: 'auto'
  },
  "& .MuiAlert-action": {
    "svg": {
      fontSize: "17px",
      marginTop: "2px"
    }
  },
  "&.MuiAlert-filledSuccess": {
    background: "#2e7d329e"
  }
});


function ToastSnackbar() {
  const [open, setOpen] = React.useState(false);
  const [notifyType, setNotifyType] = React.useState("success");

  const dispatch = useDispatch()

  const {
    notificationMessage
  } = useSelector(state => state[FEATURE_CUSTOM_PAYMENT])

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(setNotificationMessage({
      isOpen: false,
      type: null,
      message: null
    }))

    setOpen(false);
  }

  return (
    <>
      {
        notificationMessage.isOpen ?
          <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar
              open={notificationMessage.isOpen}
              className='mui-toast-notification'
              autoHideDuration={6000}
              onClose={handleClose}>
              <StyledAlert
                variant="filled"
                onClose={handleClose}
                severity={notificationMessage.type || "success"}
              >
                {notificationMessage.message || "notify"}
              </StyledAlert>
            </Snackbar>
          </Stack>
          : null
      }
    </>
  );
}

export default ToastSnackbar;
